import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getInitials(firstName: string, lastName: string): string {
  return `${firstName[0]}${lastName[0]}`.toUpperCase();
}

export function getScoreColor(score: number): string {
  if (score >= 3.5) return 'text-green-600';
  if (score >= 2.5) return 'text-yellow-600';
  return 'text-red-600';
}

export function getScoreBadge(score: number): string {
  if (score >= 3.5) return 'bg-green-100 text-green-700';
  if (score >= 2.5) return 'bg-yellow-100 text-yellow-700';
  return 'bg-red-100 text-red-700';
}
